export { OnboardingFlowProcessingHero } from './OnboardingFlowProcessingHero';
